import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { LoadingService } from '../loading/loading.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loading = inject(LoadingService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return true;
  }

  return authService.isUserLogedIn().pipe(
    take(1),
    tap(() => loading.show()),
    map((isLoggedIn) => {
      if (isLoggedIn) {
        return router.createUrlTree(['/business']);
      }
      return true;
    }),
    tap(() => loading.hide()),
    catchError(() => {
      return of(false);
    }),
  );
};
